module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "C180"
  }, [_c('p', {
    staticClass: "C275"
  }, [_vm._v(". . . . . "), _c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }), _vm._v("a faith sincere")]), _vm._v(" "), _c('p', {
    staticClass: "C276"
  }, [_vm._v("Drawn from the wisdom that begins with fear")]), _vm._v(" "), _c('p', {
    staticClass: "C276"
  }, [_vm._v("WORDSWORTH.—"), _c('em', [_vm._v("Second Evening Voluntary")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e07d308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0009.vue
// module id = 87
// module chunks = 0